import React from 'react'
import styles from './style.module.scss'
import XHeader from '../header'
import XFooter from '../footer'
import { useXTheme } from 'v2/hooks/useV2Theme'
import clsx from 'clsx'

interface Props {
    isLanguageSwitcher?: boolean
    fullHeight?: boolean
    children?: any
}

const XUnauthPage = (props: Props) => {
    const { isLanguageSwitcher, children } = props
    useXTheme()

    return (
        <div
            className={styles.unauthPage}
            style={{
                overflowY: children ? 'auto' : 'hidden',
            }}
        >
            <XHeader />
            <div
                className={clsx(
                    styles.unauthPage__content,
                    props.fullHeight ? styles.unauthPage__content__fullHeight : null
                )}
            >
                {children}
            </div>

            <XFooter isLanguageSwitcher={isLanguageSwitcher} />
        </div>
    )
}

XUnauthPage.displayName = 'XUnauthPage'

export default XUnauthPage
